import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { RegionStats } from '@/services/ragMetricsService';
import { format } from 'date-fns';
import { nb } from 'date-fns/locale';

interface RegionStatsTableProps {
  stats: RegionStats[];
}

export function RegionStatsTable({ stats }: RegionStatsTableProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Statistikk per region</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Region</TableHead>
              <TableHead>Kjøringer</TableHead>
              <TableHead>Suksessrate</TableHead>
              <TableHead>Snitt kilder</TableHead>
              <TableHead>Snitt tid</TableHead>
              <TableHead>Siste kjøring</TableHead>
              <TableHead>Avviste domener</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {stats.map((stat) => (
              <TableRow key={stat.region}>
                <TableCell className="font-medium">
                  {stat.region.charAt(0).toUpperCase() + stat.region.slice(1).replace('_', ' ')}
                </TableCell>
                <TableCell>{stat.totalRuns}</TableCell>
                <TableCell>
                  <Badge variant={stat.successRate >= 90 ? 'default' : 'destructive'}>
                    {stat.successRate.toFixed(1)}%
                  </Badge>
                </TableCell>
                <TableCell>{stat.avgSourcesFound.toFixed(1)}</TableCell>
                <TableCell>{(stat.avgExecutionTime / 1000).toFixed(1)}s</TableCell>
                <TableCell>
                  {stat.lastRun ? format(new Date(stat.lastRun), 'dd.MM.yyyy HH:mm', { locale: nb }) : '-'}
                </TableCell>
                <TableCell>{stat.rejectedDomains.length}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
